import { createContext } from 'react';

const InitialState = {
  baseUserList: [],
  userList: [],
  teamsOptions: [],
  rolesOptions: [],
  locationsOptions: [],
  editUser: {},
  userListIsLoading: true,
  selectedUserList: [],
  dynamicColState: [
    { fieldValue: 'Team', fieldState: 'teamDisplay', fieldType: 'string' },
    { fieldValue: 'Role', fieldState: 'roleDisplay', fieldType: 'string' },
  ],
  tableHeaderCheckBox: false,
  userFilterStatus: true,
  userSearchString: '',
  sortField: 'first_name',
  sortOrder: 'asc',
  sortFieldType: 'string',
  licenseList: [],
  notifyModal: {
    open: false,
    createUser: false,
    scrollToBottom: false,
  },
  voiceSetupModel: {
    open: false,
  },
  accountLevelCXWorkspaces: [],
  originalUserLevelCXWorkspaces: [],
  updatedUserLevelCXWorkspaces: [],
  newCXUserWorkspaces: [],
};

const actionTypes = {
  ADD_USER_TO_USER_LIST: 'ADD_USER_TO_USER_LIST',
  FILTER_BASE_USER_LIST: 'FILTER_BASE_USER_LIST',
  FILTER_USER_LIST: 'FILTER_USER_LIST',
  UPDATE_SELECTED_USER_COUNT: 'UPDATE_SELECTED_USER_COUNT',
  SET_EDIT_USER: 'SET_EDIT_USER',
  OPTIMISTICALLY_UPDATE_USER: 'OPTIMISTICALLY_UPDATE_USER',
  OPTIMISTICALLY_UPDATE_LICENSES: 'OPTIMISTICALLY_UPDATE_LICENSES',
  SET_USER_LIST: 'SET_USER_LIST',
  SET_BASE_USER_LIST: 'SET_BASE_USER_LIST',
  SET_DYNAMIC_COL: 'SET_DYNAMIC_COL',
  SET_LICENSE_LIST: 'SET_LICENSE_LIST',
  SET_TABLE_HEADER_STATE: 'SET_TABLE_HEADER_STATE',
  SET_USER_CHECKED_STATE: 'SET_USER_CHECKED_STATE',
  SET_USER_LIST_IS_LOADING: 'SET_USER_LIST_IS_LOADING',
  SET_USERLIST_TO_BASE: 'SET_USERLIST_TO_BASE',
  UPDATE_TABLE_SORT: 'UPDATE_TABLE_SORT',
  TOGGLE_USERS_ACTIVE_STATUS: 'TOGGLE_USERS_ACTIVE_STATUS',
  SET_TEAMS_OPTIONS: 'SET_TEAMS_OPTIONS',
  SET_ROLES_OPTIONS: 'SET_ROLES_OPTIONS',
  SET_LOCATIONS_OPTIONS: 'SET_LOCATIONS_OPTIONS',
  SET_NOTIFY_MODEL: 'SET_NOTIFY_MODEL',
  SET_VOICE_SETUP_MODEL: 'SET_VOICE_SETUP_MODEL',
  UPDATE_USER_AMAZONID: 'UPDATE_USER_AMAZONID',
  POPULATE_ACCOUNT_LEVEL_CX_WORKSPACES: 'POPULATE_ACCOUNT_LEVEL_CX_WORKSPACES',
  POPULATE_ORIGINAL_USER_LEVEL_CX_WORKSPACES:
    'POPULATE_ORIGINAL_USER_LEVEL_CX_WORKSPACES',
  POPULATE_UPDATED_USER_LEVEL_CX_WORKSPACES:
    'POPULATE_UPDATED_USER_LEVEL_CX_WORKSPACES',
  POPULATE_NEW_CX_USER_WORKSPACES: 'POPULATE_NEW_CX_USER_WORKSPACES',
};
const UserContext = createContext(InitialState);

export { UserContext };
export { InitialState };
export { actionTypes };
